import React, { Component } from 'react';

export default class PagoOperadorCellRenderer extends Component {
  render() {
    const { data } = this.props;
    return (
      <div>
        {Number(data.balance.totalBuyPrice) ===
        Number(data.balance.totalOperatorPayed) ? (
          <i
            style={{
              fontSize: 15,
              color: 'green',
            }}
            className="fa fa-check-circle-o"
            aria-hidden="true"
          />
        ) : (
          <i
            style={{
              fontSize: 15,
              color: 'red',
            }}
            className="fa fa-times-circle-o"
            aria-hidden="true"
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/PagoOperadorCellRenderer.jsx